var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"r-chart-column"},[_c('apex-chart',{attrs:{"type":"bar","height":_vm.chartOptions.chart.height || 'auto',"width":_vm.chartOptions.chart.width || '100%',"series":_vm.series,"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }